import React, { useState, useEffect } from "react";
import { UseAdvertismentGroup } from "./UseAdvertismentGroup";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";

export default function AdvertismentGroupAutoComplete(props) {
  const { getAllGroupList } = UseAdvertismentGroup();
  const [groupRes, setGroupRes] = useState();
  const [selectedGroup, setSelectedGroup] = useState();

  useEffect(() => {
    getAllGroupList((items) => {
      setGroupRes(items);
    });
  }, []);

  useEffect(() => {
    if (!props.selectedGroupID) {
      setSelectedGroup();
    }
  }, [props.selectedGroupID]);

  useEffect(() => {
    if (groupRes && props.selectedGroupID) {
      setSelectedGroup(
        groupRes.items.find((m) => m.id == props.selectedGroupID)
      );
    }
  }, [groupRes, props.selectedGroupID]);

  useEffect(() => {
    if (selectedGroup) {
      props.setState({
        ...props.state,
        groupID: selectedGroup.id,
      });
    }
  }, [selectedGroup]);

  return groupRes ? (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: props.Offer && "100%",
      }}
    >
      <Autocomplete
        id="combo-box-demo"
        value={selectedGroup ? selectedGroup : ""}
        options={groupRes.items ? groupRes.items : []}
        getOptionLabel={(items) => (items.title ? items.title : "")}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField
            error={props.errorState}
            {...params}
            label="گروه تبلیغات"
          />
        )}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.title ? option.title : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedGroup(newValue);
          } else {
            setSelectedGroup();
            props.setState({
              ...props.state,
              groupID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAllGroupList((items) => {
            setGroupRes(items);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/advertismentgroup" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
